// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

document.querySelectorAll('[data-toggle]').forEach(function(toggler) {
    toggler.addEventListener('click', function(event) {
        document.querySelector(toggler.dataset.toggle).classList.toggle('hidden');

        event.stopPropagation();
    });
});
